<form>
    <section four-columns>
        <custom-input [(value)]="domainName" [validation]="validationType.Domain" [required]="true" [label]="'company.domains.lookup-domain-input' | translate" />
        <button #lookupButton confirm (click)="lookupDomain()"><icon type="search" /> {{ buttonLabel }}</button>
    </section>
</form>
